import endpoints, { axios } from "../config/api";

function getProjectTemplateTasks(templateId: number) {
  return axios.get(endpoints.projectTemplates.getTasks(templateId));
}

export default getProjectTemplateTasks;
